import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { CheckCircle } from 'lucide-react';
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const services = [
  {
    title: 'Bespoke Applications',
    description: 'Scalable web, desktop, and mobile apps built from the ground up to match your workflows, processes, and goals.'
  },
  {
    title: 'Legacy System Modernization',
    description: 'Re-engineer outdated software into agile, modern systems — improving performance, security, and usability.'
  },
  {
    title: 'End-to-End Product Development',
    description: 'Full-cycle services from UI/UX design, architecture, coding, QA, to deployment and ongoing support.'
  },
  {
    title: 'Enterprise Software Solutions',
    description: 'Custom ERP, CRM, HRMS, and other core systems tailored to your operations, with integration-ready architecture.'
  },
  {
    title: 'API & Microservices Development',
    description: 'Build secure, modular, and interoperable systems that scale with your business using RESTful APIs and microservices.'
  },
  {
    title: 'Cloud-Native Applications',
    description: 'Harness AWS, Azure, or GCP to build resilient cloud-based apps with high availability and performance.'
  },
  {
    title: 'AI & Automation-Enabled Platforms',
    description: 'Integrate machine learning, RPA, and analytics to unlock insights and automate complex business logic.'
  },
];

const strengths = [
  'Deep domain experience across industries',
  'Agile and DevOps methodologies for rapid delivery',
  'User-centric design with enterprise-grade security',
  'Transparent communication and continuous improvement'
];

const CustomSoftwareSection = () => {
  return (
    <div>
      <Helmet>
        <title>Custom Software Design and Development | Dhanam Infosys</title>
        <meta
          name="description"
          content="Explore Dhanam Infosys' full range of custom software development services including ERP, cloud apps, microservices, automation, and more."
        />
        <link rel="canonical" href="https://dhanaminfosys.com/services" />
      </Helmet>

      <NavBar />

      {/* Hero Section */}
      <section className="about-hero text-white text-center py-5">
        <Container>
          <h1 className="fw-bold mb-3">Custom Software Design and Development</h1>
          <p className="lead">Tailored Software. Real Business Impact.</p>
        </Container>
      </section>

      {/* Services Section */}
      <Container className="py-5">
        <Row className="mb-4">
          <Col md={12} className="text-center">
            <p>
              At Dhanam Information Systems, we specialize in delivering custom software solutions
              that are purpose-built to address your unique business challenges. From ideation to
              deployment, our experienced team designs and develops software that drives operational
              efficiency, enhances digital portfolios, and empowers smarter decision-making.
            </p>
          </Col>
        </Row>

        <Row>
          {services.map((service, idx) => (
            <Col md={6} lg={4} className="mb-4" key={idx}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h5><CheckCircle className="me-2 text-primary" size={20} />{service.title}</h5>
                  <p>{service.description}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <h4 className="mb-3">Our Edge</h4>
            <ul className="list-unstyled">
              {strengths.map((point, idx) => (
                <li key={idx} className="mb-2 d-flex align-items-start">
                  <CheckCircle className="me-2 text-success" size={18} /> <span>{point}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4">
              From concept to code — we build what your business needs to grow.
              <br />
              Partner with <strong>Dhanam Information Systems</strong> for intelligent, future-ready software solutions that deliver measurable outcomes.
            </p>
          </Col>
        </Row>
      </Container>

      <Footer />

      {/* Scoped Styles */}
      <style jsx="true">{`
        .about-hero {
          background-color: #0b163f;
        }
        ul {
          list-style: none;
          padding-left: 0;
        }
        ul li {
          margin-bottom: 10px;
          white-space: nowrap;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
      `}</style>
    </div>
  );
};

export default CustomSoftwareSection;
